/**
 * 简体中文
 */
export default {
  header: {
    lang: '简繁切换',
    app: 'APP下载',
    about: '关于我们'
  },
  footer: {
    youth: '青少年安全上网',
    declare: '免责声明',
    private: '隐私政策',
    copyright: ' All Rights Reserved.',
    icp: '苏ICP备14027754号-4',
    browser360: '下载360极速浏览器',
    browserqq: '下载QQ浏览器'
  },
  sidebar: {
    feedback: '在线反馈',
    onlineService: '在线咨询',
    app: '扫码下载',
    help: '帮助中心',
    top: '返回顶部',
    appDialog: {
      tips: '学生端扫码下载'
    },
    fbDialog: {
      title: '在线反馈',
      contact: '联系方式',
      contactPH: 'QQ\\E-mail\\手机号',
      suggest: '问题或建议',
      submit: '提交',
      submitComplete: '提交完成！',
      thank: '你的信息反馈我们已经收到，我们会尽快给你答复，谢谢~',
      continue: '继续反馈'
    }
  },
  Login: {
    register: {
      title: '注册学生账号',
      phoneNumber: '手机号',
      captcha: '图形验证码',
      captchaPh: '请输入图形验证码',
      changeOne: '换一个',
      phoneCode: '手机验证码',
      phoneCodePh: '请输入手机验证码',
      getCode: '获取验证码',
      password: '密码',
      passwordPh: '请输入密码',
      certifyPassword: '确认密码',
      newPasswordPh: '请再次输入密码',
      accept: '我已阅读并接受',
      agreement: '《用户服务协议》',
      rMsg: '下一步',
      haveOne: '已有账号?',
      rightNow: '立即登录',
      error: {
        phoneError: '请输入11位手机号码',
        phoneCodeError: '手机验证码不正确',
        captchaError: '请输入4位图形校验码',
        pwdEmpty: '密码不能为空',
        pwdInconsistent: '两次密码输入不一致'
      }
    },
    loginBody: {
      identity: ['学生', '教师', '教研'],
      tidentity: ['教师', '教研'],
      login: '登 录',
      rememberPass: '记住密码',
      forgetPass: '忘记密码',
      downloadQR: '扫码下载APP',
      register: '立即注册',
      downloadByPhone: '手机扫码下载',
      studentMobile: '学生端APP下载',
      teacherMobile: '教师端APP下载'
    },
    Activation: {
      title: '欢迎使用' + window.ConfigNew.header.name + '，请激活账号',
      requiredPh: '请输入激活码',
      save: '激活账号',
      saveing: '正在验证',
      preject: '完善个人信息'
    },
    PerfectInfo: {
      title: '请完善个人信息',
      attention: '必填信息(*)提交后不可更改，请谨慎操作！',
      schoolMsg: '若下拉菜单中没有找到你的学校，请联系教师',
      name: '姓名',
      namePh: '请填写真实姓名',
      sex: '性别',
      sexDefault: '男',
      sexOther: '女',
      area: '地区',
      school: '学校',
      schoolPh: '请选择所在学校',
      categroy: '年级',
      categroyPh: '请选择所在年级',
      class: '班级',
      classPh: '请选择所在班级',
      save: '保存'
    },
    edit: {
      title: '请修改个人信息'
    },
    perfect: {
      title: '注册成功，请完善个人信息',
      name: '姓名：',
      namePh: '请填写你的身份证或户口本上的姓名',
      sex: '性别：',
      sexDefault: '男',
      sexOther: '女',
      idNumber: '身份证',
      idNumberPh: '请正确填写15位或18位身份证号码',
      area: '所在地区：',
      school: '所在学校：',
      other: '其他',
      schoolMsg: '若下拉菜单中没有找到你的学校，请在“其他”框输入学校名称',
      schoolPh: '请输入学校名称',
      categroy: '所在年级：',
      class: '所在班级：',
      teacher: '辅导教师：',
      teacherPh: '请输入辅导教师名称',
      teacherPhone: '教师电话：',
      teacherPhonePh: '请输入辅导教师电话',
      attention: '必填信息(*)提交后不可更改，请谨慎操作！',
      schoolKey: '关键字搜索学校',
      save: '保存',
      error: {
        stuNameErrMsg: '学生名字不能为空',
        idNumberErrMsg: '身份证格式不正确',
        teaNameErrMsg: '教师姓名不能为空',
        teaNumberErrMsg: '辅导教师号码格式不正确',
        schoolErrMsg: '请选择学校',
        categoryErrMsg: '请选择所在年级',
        classErrMsg: '请选择所在班级',
        areaErrMsg: '请选择省市区'
      }
    },
    findPwd: {
      title: '找回密码',
      step: ['确认账号', '修改密码', '完成'],
      phone: '手机号',
      phonePH: '请输入手机号',
      verify: '验证码',
      verifyPH: '请输入手机验证码',
      verifyBtn: '获取验证码',
      newPwd: '设置新密码',
      newPwdPH: '请输入新密码',
      newPwd2: '再次输入新密码',
      newPwdPH2: '请输入新密码',
      next: '下一步',
      relogin: '重新登录',
      success: '密码修改成功',
      tips: '温馨提示：系统仅支持已绑定手机号码的账号，找回密码',
      loginin: '进入学生端',
      error: {
        phoneError: '请输入11位手机号码',
        verifyEmpty: '验证码不能为空',
        pwdInconsistent: '密码设置不一致',
        pwdEmpty: '密码不能为空'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/i18n/zh.js